import { useState, useEffect } from "react";
import { supabase } from "./db";

export default function SupplierProfile({ session }) {
  const [profile, setProfile] = useState({
    company_name: "",
    contact_person: "",
  });
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [profileMessage, setProfileMessage] = useState("");

  const [passwordForm, setPasswordForm] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState("");

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const { data, error } = await supabase
      .from("profiles")
      .select("company_name, contact_person")
      .eq("id", session.user.id)
      .single();

    if (data && !error) {
      setProfile({
        company_name: data.company_name || "",
        contact_person: data.contact_person || "",
      });
    }
  };

  const handleSaveProfile = async () => {
    setProfileMessage("");
    const { error } = await supabase
      .from("profiles")
      .update({
        company_name: profile.company_name,
        contact_person: profile.contact_person,
      })
      .eq("id", session.user.id);

    if (error) {
      setProfileMessage("❌ Chyba pri ukladaní profilu: " + error.message);
    } else {
      setProfileMessage("✅ Profil bol úspešne aktualizovaný.");
      setIsEditingProfile(false);
      setTimeout(() => setProfileMessage(""), 3000);
    }
  };

  const handleSavePassword = async () => {
    setPasswordMessage("");
    if (passwordForm.newPassword.length < 6) {
      setPasswordMessage("❌ Heslo musí mať aspoň 6 znakov.");
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordMessage("❌ Heslá sa nezhodujú.");
      return;
    }
    const { error } = await supabase.auth.updateUser({
      password: passwordForm.newPassword,
    });
    if (error) {
      setPasswordMessage("❌ Chyba pri zmene hesla: " + error.message);
    } else {
      setPasswordMessage("✅ Heslo bolo úspešne zmenené.");
      setIsEditingPassword(false);
      setPasswordForm({ newPassword: "", confirmPassword: "" });
      setTimeout(() => setPasswordMessage(""), 3000);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #cbd5e1",
    marginBottom: "10px",
    fontSize: "14px",
  };

  return (
    <div
      className="card"
      style={{
        padding: "20px",
        marginBottom: "20px",
        backgroundColor: "#f8fafc",
        border: "1px solid #e2e8f0",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #cbd5e1",
          paddingBottom: "10px",
          marginBottom: "15px",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            color: "#1e293b",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>👤</span> Profil dodávateľa
        </h2>
      </div>

      {profileMessage && (
        <div
          className="alert-success"
          style={{ padding: "8px", marginBottom: "15px", fontSize: "13px" }}
        >
          {profileMessage}
        </div>
      )}
      {passwordMessage && (
        <div
          className={
            passwordMessage.includes("❌") ? "alert-error" : "alert-success"
          }
          style={{ padding: "8px", marginBottom: "15px", fontSize: "13px" }}
        >
          {passwordMessage}
        </div>
      )}

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {/* OSOBNÉ ÚDAJE */}
        <div
          style={{
            flex: 1,
            minWidth: "250px",
            backgroundColor: "white",
            padding: "15px",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <h3 style={{ margin: 0, fontSize: "15px", color: "#334155" }}>
              Firemné údaje
            </h3>
            {!isEditingProfile && (
              <button
                onClick={() => setIsEditingProfile(true)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#3b82f6",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                ✏️ Upraviť
              </button>
            )}
          </div>

          {isEditingProfile ? (
            <div>
              <label
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  display: "block",
                  marginBottom: "3px",
                }}
              >
                Názov firmy:
              </label>
              <input
                type="text"
                value={profile.company_name}
                onChange={(e) =>
                  setProfile({ ...profile, company_name: e.target.value })
                }
                style={inputStyle}
              />
              <label
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  display: "block",
                  marginBottom: "3px",
                }}
              >
                Kontaktná osoba (Meno):
              </label>
              <input
                type="text"
                value={profile.contact_person}
                onChange={(e) =>
                  setProfile({ ...profile, contact_person: e.target.value })
                }
                style={inputStyle}
              />
              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button
                  onClick={handleSaveProfile}
                  className="btn-success"
                  style={{ padding: "6px 12px", fontSize: "12px" }}
                >
                  💾 Uložiť
                </button>
                <button
                  onClick={() => {
                    setIsEditingProfile(false);
                    fetchProfile();
                  }}
                  className="btn-outline"
                  style={{ padding: "6px 12px", fontSize: "12px" }}
                >
                  Zrušiť
                </button>
              </div>
            </div>
          ) : (
            <div>
              <p
                style={{ margin: "5px 0", fontSize: "14px", color: "#0f172a" }}
              >
                <strong>Firma:</strong>{" "}
                {profile.company_name || (
                  <span style={{ color: "#94a3b8", fontStyle: "italic" }}>
                    Nezadané
                  </span>
                )}
              </p>
              <p
                style={{ margin: "5px 0", fontSize: "14px", color: "#0f172a" }}
              >
                <strong>Meno:</strong>{" "}
                {profile.contact_person || (
                  <span style={{ color: "#94a3b8", fontStyle: "italic" }}>
                    Nezadané
                  </span>
                )}
              </p>
            </div>
          )}
        </div>

        {/* HESLO */}
        <div
          style={{
            flex: 1,
            minWidth: "250px",
            backgroundColor: "white",
            padding: "15px",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <h3 style={{ margin: 0, fontSize: "15px", color: "#334155" }}>
              Bezpečnosť
            </h3>
            {!isEditingPassword && (
              <button
                onClick={() => setIsEditingPassword(true)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#3b82f6",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                🔑 Zmeniť heslo
              </button>
            )}
          </div>

          {isEditingPassword ? (
            <div>
              <label
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  display: "block",
                  marginBottom: "3px",
                }}
              >
                Nové heslo (min. 6 znakov):
              </label>
              <input
                type="password"
                value={passwordForm.newPassword}
                onChange={(e) =>
                  setPasswordForm({
                    ...passwordForm,
                    newPassword: e.target.value,
                  })
                }
                style={inputStyle}
              />
              <label
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  display: "block",
                  marginBottom: "3px",
                }}
              >
                Potvrdiť nové heslo:
              </label>
              <input
                type="password"
                value={passwordForm.confirmPassword}
                onChange={(e) =>
                  setPasswordForm({
                    ...passwordForm,
                    confirmPassword: e.target.value,
                  })
                }
                style={inputStyle}
              />
              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button
                  onClick={handleSavePassword}
                  className="btn-success"
                  style={{ padding: "6px 12px", fontSize: "12px" }}
                >
                  💾 Zmeniť
                </button>
                <button
                  onClick={() => {
                    setIsEditingPassword(false);
                    setPasswordForm({ newPassword: "", confirmPassword: "" });
                  }}
                  className="btn-outline"
                  style={{ padding: "6px 12px", fontSize: "12px" }}
                >
                  Zrušiť
                </button>
              </div>
            </div>
          ) : (
            <div>
              <p
                style={{
                  margin: "5px 0",
                  fontSize: "13px",
                  color: "#64748b",
                  lineHeight: "1.5",
                }}
              >
                Svoje heslo môžete kedykoľvek bezpečne zmeniť. Kliknite na
                tlačidlo "Zmeniť heslo".
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
